(() => {
  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function findScrollableViewport(gallery) {
    // Procurar dentro do media-gallery algo que realmente role horizontalmente
    const candidates = gallery.querySelectorAll("*");
    for (const el of candidates) {
      // precisa ser elemento visível
      if (!(el instanceof HTMLElement)) continue;
      const style = getComputedStyle(el);
      const canScrollX = /auto|scroll/.test(style.overflowX) || /auto|scroll/.test(style.overflow);
      if (!canScrollX) continue;

      if (el.scrollWidth > el.clientWidth + 2) {
        return el;
      }
    }
    return null;
  }

  function setupOneGallery(gallery) {
    if (!gallery || gallery.dataset.ezPdpArrowsInit === "1") return;

    const arrowsWrap = gallery.querySelector(".ez-pdp-mobile-arrows");
    if (!arrowsWrap) return;

    const prev = arrowsWrap.querySelector(".ez-pdp-arrow--prev");
    const next = arrowsWrap.querySelector(".ez-pdp-arrow--next");
    if (!prev || !next) return;

    const viewport = findScrollableViewport(gallery);
    if (!viewport) {
      // se não achou nada rolável, esconde as setas
      arrowsWrap.style.display = "none";
      return;
    }

    gallery.dataset.ezPdpArrowsInit = "1";

    const step = () => Math.max(1, viewport.clientWidth);

    function updateDisabled() {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 2) {
        arrowsWrap.style.display = "none";
        return;
      }
      arrowsWrap.style.display = "";

      const left = viewport.scrollLeft;
      const atStart = left <= 2;
      const atEnd = left >= max - 2;

      prev.disabled = atStart;
      next.disabled = atEnd;

      prev.classList.toggle("is-disabled", atStart);
      next.classList.toggle("is-disabled", atEnd);
    }

    prev.addEventListener("click", () => {
      viewport.scrollBy({ left: -step(), behavior: "smooth" });
    });

    next.addEventListener("click", () => {
      viewport.scrollBy({ left: step(), behavior: "smooth" });
    });

    viewport.addEventListener(
      "scroll",
      () => window.requestAnimationFrame(updateDisabled),
      { passive: true }
    );

    window.addEventListener("resize", () => {
      if (!isMobile()) return; // só nos importa mobile
      updateDisabled();
    });

    updateDisabled();
  }

  function init() {
    if (!isMobile()) return;

    // Horizon: o wrapper que você tem é <media-gallery class="... media-gallery--carousel ...">
    document
      .querySelectorAll("media-gallery.media-gallery--carousel")
      .forEach(setupOneGallery);
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);

  // caso a galeria seja hidratada depois
  const mo = new MutationObserver(() => init());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
